<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content >
    
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Name of the expense</mat-label>
        <input
          [(ngModel)]="otherExpenseData.label"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea
          [(ngModel)]="otherExpenseData.reason"
          matInput
          #input
        ></textarea>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Expense amount</mat-label>
        <input 
          [(ngModel)]="otherExpenseData.amount"
          matInput
          #input
           smDecimalOnly  type="number"
        />
      </mat-form-field>
    </div>
  
      <div>
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker0.open()" style="padding: 0px;">
            <mat-label>Select Date</mat-label>
            <input matInput [matDatepicker]="picker0" [(ngModel)]="otherExpenseData.expenseDateTime" readonly [max]="maxDate">
    
            <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
            <mat-datepicker #picker0 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
      
  </mat-dialog-content>
<!-- 
  <mat-dialog-content *ngIf="editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          [(ngModel)]="editCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Status: </label>
        <mat-radio-group [(ngModel)]="editCreditData.status">
          <mat-radio-button [value]="1">Active</mat-radio-button>
          <mat-radio-button [value]="0">Paid Fully</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content> -->
  
  <mat-dialog-actions align="end" style="position: relative !important; right: 14px;">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="!otherExpenseData.label  || !otherExpenseData.amount || !otherExpenseData.expenseDateTime || otherExpenseData.amount == 0"
      (click)="onPost()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
  